/**
 * Regular expression patterns and utilities - migrated from jl-design-system/form/regex
 */

/**
 * Pattern for ASCII extended characters (printable ASCII)
 * Matches letters, numbers, spaces, and common punctuation
 */
export const asciiExtendedPattern = /^[\x20-\x7E]*$/;

/**
 * Creates a RegExp object from a pattern string or existing RegExp
 * @param {string|RegExp} pattern - The pattern to convert
 * @returns {RegExp} - The RegExp object
 */
const getRegExp = (pattern) => {
  if (pattern instanceof RegExp) {
    return pattern;
  }
  return new RegExp(pattern);
};

export default getRegExp;
